import { apiGet } from "@redriver/cinnamon";

const NAMESPACE = "BOOKINGS";
const ActionTypes = {
  GetBookings: `${NAMESPACE}/GET_BOOKINGS`,
};

export const getBookingsList = ({ pagination }, { from, to }) => {
  const { pageSize, pageNumber } = pagination;
  return apiGet(ActionTypes.GetBookings, "booking/resortRep", {
    pageNumber,
    pageSize,
    departDateFrom: from,
    departDateTo: to,
  });
};
